import { render, staticRenderFns } from "./Table3.vue?vue&type=template&id=5a4383a6"
import script from "./Table3.vue?vue&type=script&lang=js"
export * from "./Table3.vue?vue&type=script&lang=js"
import style0 from "./Table3.vue?vue&type=style&index=0&id=5a4383a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports